import React from 'react'
import { Link } from 'react-router'
import { Glyphicon, Panel, FormGroup, ControlLabel, FormControl, Button } from 'react-bootstrap'

import { resetPassword } from '../lib/APIClient.js'

const styles = {
  panel: { margin : "40px" },
  button: { marginTop: "20px" },
  inputGroup: { marginBottom: 10, marginTop: 20 }, 
  input: { maxWidth: "200px" }
}

class ResetPassword extends React.PureComponent
{
  constructor(props) {
    super(props)
    this.state = { 
      password: "", 
      sent: false, 
      done: false, 
      errorMessage: null, 
    }
  }
  
  reset() {
    this.setState({ sent: true, errorMessage: null })
    
    resetPassword(
      this.props.routeParams.username, 
      this.props.routeParams.token, 
      this.state.password,
      (error, data) => {
        console.log({ error, data })
        
        if (data.ok) {
          console.log(`resetpassword success, done!`)
          this.setState({ done: true })
        }
        else if (data.passwordErrors) {
          this.setState({ 
            sent: false, 
            errorMessage: "La contraseña no es lo bastante segura: " + data.passwordErrors[0]
          })
        }
        else {
          console.log(`resetpassword error!`)
          if (error && error.status == 401) {
            this.setState({ errorMessage: "No autorizado; este enlace ya fue usado o ha caducado", sent: false })
          }
          else {
            this.setState({ errorMessage: `Error: ${error.message}`, sent: false })
          }
        }
      }
    ) 
  }

  render() {
    return (
      <Panel style={styles.panel}>
        <Panel.Body>

          <Link to="/login" style={{fontWeight: "bold", fontSize: "15px"}}>
            {"< Volver a Login"}
          </Link>

          <form>

            <FormGroup controlId="login-name" style={styles.inputGroup}>
              <ControlLabel>Nueva contraseña</ControlLabel>
              <div style={{maxWidth: 400}}>
                <i>
                  La contraseña debe tener al menos 10 caracteres. Es importante que no incluya palabras comunes, que tenga letras y números, y que no sea fácil de adivinar.
                </i>
              </div>
              <FormControl 
                type="password" 
                style={styles.input}
                value={this.state.password}
                onChange={evt => this.setState({ password: evt.target.value, errorMessage: null })}
                disabled={this.state.sent}
              />
            </FormGroup>
            
            { 
              this.state.errorMessage && (
                <span style={{color: "red", fontWeight: "bold"}}>
                  <Glyphicon glyph="warning-sign" />{" "}
                  {this.state.errorMessage}
                  <br />
                </span>
              )
            }
            
            {
              this.state.done && (
                <span style={{color: "green", fontWeight: "bold"}}>
                  <Glyphicon glyph="ok" />{" "}
                  Contraseña reseteada correctamente
                  <br />
                </span>
              )
            }

            <Button 
              style={styles.button}
              onClick={() => this.reset()}
              disabled={this.state.sent}
              type="submit"
            >
              <Glyphicon glyph={ this.state.sent ? "retweet" : "save" }/>{" "}
              Guardar contraseña
            </Button>

          </form>

        </Panel.Body>   
      </Panel>
    )
  }
}

export default ResetPassword
